import { dashboardService } from '@/services';

// Rows shown in the stock breaks and top products blocks (the back accepts 1-10).
const TOP_ROWS = 8;

function block(data) {
  return { data, loading: false, error: null };
}

// Load one block into state[key]; the services already resolve with the data.
function loadBlock(state, key, request) {
  state[key].loading = true;
  request
    .then((res) => {
      state[key].data = res;
      state[key].error = null;
    })
    .catch((error) => {
      state[key].error = error;
    })
    .finally(() => {
      state[key].loading = false;
    });
}

export const dashboardOverviewModule = {
  namespaced: true,
  state: () => ({
    days: '30',
    kpis: block({
      orders_received: 0,
      orders_shipped: 0,
      orders_stock_break: 0,
      purchases_pending: 0,
      orders_back_pending: 0,
    }),
    orderStatus: block({ total: 0, groups: [] }),
    preparationTime: block({ total: 0, buckets: [] }),
    shipmentsByCourier: block({ total: 0, items: [] }),
    stockBreaks: block({ items: [] }),
    topProducts: block({ items: [] }),
    alerts: block({
      products_not_registered: { count: 0, level: 'ok' },
      orders_not_registered: { count: 0, level: 'ok' },
      purchases_not_registered: { count: 0, level: 'ok' },
      orders_back_not_registered: { count: 0, level: 'ok' },
      shipments_without_tracking: { count: 0, level: 'ok' },
    }),
  }),
  mutations: {
    setDays(state, days) {
      state.days = days;
    },
    getKpis(state) {
      loadBlock(state, 'kpis', dashboardService.getKpis(state.days));
    },
    getOrderStatus(state) {
      loadBlock(state, 'orderStatus', dashboardService.getOrderStatus(state.days));
    },
    getPreparationTime(state) {
      loadBlock(state, 'preparationTime', dashboardService.getPreparationTime(state.days));
    },
    getShipmentsByCourier(state) {
      loadBlock(state, 'shipmentsByCourier', dashboardService.getShipmentsByCourier(state.days));
    },
    getStockBreaks(state) {
      loadBlock(state, 'stockBreaks', dashboardService.getStockBreaks(state.days, TOP_ROWS));
    },
    getTopProducts(state) {
      loadBlock(state, 'topProducts', dashboardService.getTopProducts(state.days, TOP_ROWS));
    },
    getAlerts(state) {
      loadBlock(state, 'alerts', dashboardService.getAlerts());
    },
  },
  actions: {
    // Reload every block that depends on the period.
    loadPeriod({ commit }, days) {
      commit('setDays', days);
      commit('getKpis');
      commit('getOrderStatus');
      commit('getPreparationTime');
      commit('getShipmentsByCourier');
      commit('getStockBreaks');
      commit('getTopProducts');
    },
    loadAll({ dispatch, commit, state }) {
      dispatch('loadPeriod', state.days);
      commit('getAlerts');
    },
  },
};
